'use client';
import React, { useState } from 'react';
import Link from 'next/link';

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-sm border-b border-white/10 px-6 py-3" style={{ backgroundColor: 'rgba(16, 11, 40, 0.95)' }}>
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-6">
          <Link href="/Home" className="flex items-center gap-2 flex-shrink-0">
            <div className="w-7 h-7 bg-violet-600 rounded-md flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 text-white">
                <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" />
              </svg>
            </div>
            <span className="text-white font-bold text-base">HabitLab</span>
          </Link>
          <nav className="hidden sm:flex items-center gap-1">
            <Link href="/Home" className="px-3 py-1.5 rounded-md text-white/80 hover:text-white hover:bg-white/10 text-sm font-medium transition-colors">Home</Link>
            <Link href="/About" className="px-3 py-1.5 rounded-md text-white/80 hover:text-white hover:bg-white/10 text-sm font-medium transition-colors">About</Link>
            <Link href="/Features" className="px-3 py-1.5 rounded-md text-white/80 hover:text-white hover:bg-white/10 text-sm font-medium transition-colors">Features</Link>
            <Link href="/Pricing" className="px-3 py-1.5 rounded-md text-white/80 hover:text-white hover:bg-white/10 text-sm font-medium transition-colors">Pricing</Link>
          </nav>
        </div>
        <div className="hidden sm:flex items-center gap-3 flex-shrink-0">
          <Link href="/login" className="px-3 py-1.5 rounded-md text-white/80 hover:text-white hover:bg-white/10 text-sm font-medium transition-colors">Log In</Link>
          <Link href="/GetStarted" className="px-4 py-1.5 bg-violet-600 hover:bg-violet-500 text-white text-sm font-semibold rounded-md transition-all">Get Started</Link>
        </div>
        <button
          className="sm:hidden text-white/70 hover:text-white p-1"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5">
            <line x1="4" x2="20" y1="12" y2="12" />
            <line x1="4" x2="20" y1="6" y2="6" />
            <line x1="4" x2="20" y1="18" y2="18" />
          </svg>
        </button>
      </div>
      {mobileOpen && (
        <div className="sm:hidden mt-2 pb-3 border-t border-white/10">
          <nav className="flex flex-col gap-1 pt-3">
            <Link href="/Home" className="px-3 py-2 rounded-md text-white/80 hover:text-white hover:bg-white/10 text-sm font-medium transition-colors" onClick={() => setMobileOpen(false)}>Home</Link>
            <Link href="/About" className="px-3 py-2 rounded-md text-white/80 hover:text-white hover:bg-white/10 text-sm font-medium transition-colors" onClick={() => setMobileOpen(false)}>About</Link>
            <Link href="/Features" className="px-3 py-2 rounded-md text-white/80 hover:text-white hover:bg-white/10 text-sm font-medium transition-colors" onClick={() => setMobileOpen(false)}>Features</Link>
            <Link href="/Pricing" className="px-3 py-2 rounded-md text-white/80 hover:text-white hover:bg-white/10 text-sm font-medium transition-colors" onClick={() => setMobileOpen(false)}>Pricing</Link>
            <div className="flex items-center gap-3 px-3 pt-2">
              <Link href="/login" className="text-white/80 hover:text-white text-sm font-medium transition-colors" onClick={() => setMobileOpen(false)}>Log In</Link>
              <Link href="/GetStarted" className="px-4 py-1.5 bg-violet-600 hover:bg-violet-500 text-white text-sm font-semibold rounded-md transition-all" onClick={() => setMobileOpen(false)}>Get Started</Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
